import { useEffect } from "react";
import { useRecoilValue } from "recoil";

import { useApplication } from "@ryde/redux";
import { APP_VERSION, profileScopeAtom } from "@ryde/shared";

export const DocumentTitle = (): null => {
  const scope = useRecoilValue(profileScopeAtom);
  const { isAdminApp } = useApplication();

  useEffect(() => {
    const baseTitleName = isAdminApp ? "Admin Ryde" : "Ryde Manager";
    const baseTitle = `${baseTitleName} ${APP_VERSION}`;
    const companyName = scope?.companyName;

    if (companyName) {
      document.title = `${companyName} | ${baseTitle}`;
    } else {
      document.title = baseTitle;
    }
  }, [scope?.companyName, isAdminApp]);

  return null;
};
